// this is an autogenerated file from DesignSystem/AppointmentActions/CancelNoShow/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AppointmentActions_CancelNoShow_Content($appointment_id: uuid!) {
  vaxiom_appointments(where: { _id: { _eq: $appointment_id } }) {
    id
    booking {
      _id
    }
  }
}

`